import { render } from "./Allocation.vue?vue&type=template&id=7c14d1c7&scoped=true"
import script from "./Allocation.vue?vue&type=script&lang=js"
export * from "./Allocation.vue?vue&type=script&lang=js"

import "./Allocation.vue?vue&type=style&index=0&id=7c14d1c7&scoped=true&lang=css"
import "./Allocation.vue?vue&type=style&index=1&id=7c14d1c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Z\\Desktop\\7\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c14d1c7"]])

export default __exports__